export default "__VITE_ASSET__BZzJhJwG__"